import { Activity as ReactActivity, ReactNode } from "react";

interface Props {
  isVisible: boolean;
  children?: ReactNode;
}

export const Activity = ({ isVisible, children }: Props) => {
  return <ReactActivity mode={(isVisible && "visible") || "hidden"}>{children}</ReactActivity>;
};
